/* eslint-disable arrow-parens */
import { FunctionComponent, useState } from 'react'

import { Wrapper, TooltipBox, TooltipText } from './tooltip.styles'
import { TooltipProps } from './tooltip.types'

const Tooltip: FunctionComponent<TooltipProps> = ({ text, children }) => {
  const [isClicked, setIsClicked] = useState(false)

  return (
    <Wrapper onClick={() => setIsClicked(!isClicked)}>
      <TooltipBox isClicked={isClicked}>
        <TooltipText>{text}</TooltipText>
      </TooltipBox>
      {children}
    </Wrapper>
  )
}

export default Tooltip
